export class Badge {
  /**
   * @var {string}
   */
  text;

  /**
   * @var {string}
   */
  type;

  constructor(model = {}) {
    this.text = model.text;
    this.type = model.type;
  }
}
